import Spine from 'core/display/Spine'
import { signal } from 'services/SignalsService'
import { StoreageService } from 'services/StoreageService'

export class AnimationSpine extends Spine {
  constructor(data) {
    super(data)
    this._data = data
    this.scale.set(    this._data.scale ?    this._data.scale : 1)

    if (this._data.sv) {
      this.scale.set(this._data.sv, this._data.sh)
    }

    if (this._data.oriented){
      this.orientation.call(this)
    }
    else {
      this.regular.call(this)
    }
    if(this._data.winAnimation){
      signal.on('WIN-ANIMATE', () => {
        this.play(this._data.bigWin, false)
      })

      signal.on('WIN-ANIMATE:DONE', () => {
        this.play(this._data.animation, false)
      })
    }
  }

  regular(){
    this.play(this._data.animation, true)
  }

  orientation() {
    const self = this

    signal.on('RESIZE', async function ({ orientation }) {
      self.currentOrientation = orientation
      if (self._data.animation) {
        self.play(self._data.directionAnim && StoreageService.get('left') && orientation == 'land'
          ? 'left-' + self._data.animation + '-' + orientation
          : self._data.animation + '-' + orientation, true)
      }
      else if (self._data.animations) { //todo circus 1 animation only...
        const [f, s] = self._data.animations
        await self.play(f + '-' + orientation, false)
        self.play(s + '-' + orientation)
      }
      else {
        self.play(self._data.directionAnim && StoreageService.get('left') && orientation == 'land'
          ? 'left-' + orientation
          : orientation, true)
      }
    })

    if (self._data.directionAnim) {
      signal.on('TOGGLE:left', function (left) {

        const { orientation } = game.models.SizeModel.size

        if (self._data.animation) {
          self.play(left && orientation == 'land'
            ? 'left-' + self._data.animation + '-' + orientation
            : self._data.animation + '-' + orientation, true)
        }
        else {
          self.play(left && orientation == 'land'
            ? 'left-' + orientation
            : orientation, true)
        }
      })
    }
  }
}
